<template>
  <b-modal
      no-close-on-backdrop
      no-close-on-esc
      hide-header
      hide-footer
      centered
      v-model="modalShow"
  >
    <div class="d-flex flex-column align-items-center justify-center-center my-2">
      <feather-icon
          id="view-departamento"
          icon="AlertCircleIcon"
          class="text-danger mb-2"
          size="80"
      />
      <h3>Esta campanha não está mais vigente</h3>
      <span class="text-center content-modal">
        Você está cadastrando um agendamento para uma campanha que já concluiu seu período de vigência. <br>
        Tem certeza que deseja continuar?
      </span>
      <div class="d-flex mt-2">
        <b-button :disabled="loading" variant="outline-danger" class="mr-2" @click="cancelAction">
          Cancelar
        </b-button>
        <b-button :disabled="loading" variant="primary-button" @click="confirmAction" >
          <span v-if="loading" class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
          Sim, continuar
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { BModal, BButton } from 'bootstrap-vue';
export default {
  components: {
    BModal, BButton
  },

  props: {
    modalShow: {
      required: true,
      type: Boolean
    }
  },

  data() {
    return {
      loading: false
    }
  },

  methods: {
    confirmAction(modalEvent) {
      modalEvent.preventDefault();

      this.loading = true;

      this.$emit('confirmed', modalEvent);
    },

    cancelAction(modalEvent) {
      modalEvent.preventDefault();

      this.$emit('canceled', modalEvent);
    },
  },

  watch: {
    modalShow() {
      this.loading = false;
    }
  }
}
</script>

<style scoped>
.content-modal {
  max-width: 80%;
}
</style>
